import {
    getComposeEvent,
    getOpenedForm,
    getFullComposeViewState,
} from 'owa-calendar-compose-store-manager';
import {
    getComposeHostItemIndex,
    lazyAllowItemSendEvent,
    lazyShouldAddinsForceOnSendCompliantBehavior,
} from 'owa-addins-core';
import insertAppendOnSend from 'owa-addins-editor-plugin/lib/utils/insertAppendOnSend';
import { isEventAMeeting } from 'owa-calendar-event-capabilities';
import { QUICK_COMPOSE_FORM_TYPE } from 'owa-calendar-helpers-types/lib/ComposeTypes';
import { updateUIEnabled } from 'owa-calendar-compose-form-actions';
import { isFeatureEnabled } from 'owa-feature-flags';

export default async function validateSend(formId: string, targetWindow: Window): Promise<boolean> {
    const event = getComposeEvent(formId);
    const openedForm = getOpenedForm(formId);
    const fullComposeViewState = getFullComposeViewState(formId);

    if (isEventAMeeting(event) && !event.IsDraft && openedForm !== QUICK_COMPOSE_FORM_TYPE) {
        await insertAppendOnSend(fullComposeViewState.bodyViewState, fullComposeViewState.addin);

        if (isFeatureEnabled('addin-popoutComposeAndSend')) {
            const shouldForceOnSendCompliantBehavior = await lazyShouldAddinsForceOnSendCompliantBehavior.import();
            if (shouldForceOnSendCompliantBehavior()) {
                updateUIEnabled(false, formId);
            }
        }

        const shouldAllowItemSendEvent = await lazyAllowItemSendEvent.import();
        if (!(await shouldAllowItemSendEvent(getComposeHostItemIndex(formId), targetWindow))) {
            updateUIEnabled(true, formId);
            return false;
        }
        updateUIEnabled(true, formId);
    }
    return true;
}
